import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import environment from '@menu-environment';
import { Button } from 'components/buttons/button';
import { ButtonSize, ButtonType } from 'components/buttons/button-types';
import { Card } from 'components/cards/card';
import { CardThemeType } from 'components/cards/card-type';
import { FeatureFlag } from 'core/enums/feature-flag';
import { usePlatform } from 'core/hooks/platform';
import myDstvLogo from '../../../assets/img/my-dstv-logo.png';
import styles from './maintenance.module.scss';

const Maintenance = observer(
  ({
    panelType,
  }: {
    panelType: FeatureFlag.ScheduledMaintenancePanel | FeatureFlag.UnexpectedMaintenancePanel | false;
  }) => {
    const { t } = useTranslation();
    const { translate } = usePlatform();

    return (
      <Card backgroundType={CardThemeType.Glass} classes={['cust-mb-4', 'primary-glass']}>
        <div className="d-flex flex-column align-items-center">
          <img src={myDstvLogo} alt={'My DStv Logo'} className={styles.logo} />
          <h3 className="cust-mb-2">{t('maintenance.header')}</h3>

          {panelType === FeatureFlag.ScheduledMaintenancePanel && (
            <p className="text-paragraph-regular text-center cust-mb-2">
              {`${translate('maintenance.description')} `} {moment().add(4, 'hours').format('HH:MM, DD MMM')}.
            </p>
          )}
          {panelType === FeatureFlag.UnexpectedMaintenancePanel && (
            <>
              <p className="text-paragraph-regular text-center no-margin">
                {' '}
                {translate('maintenance.techcalDifficulty')}
              </p>
              <p className="text-paragraph-regular text-center no-margin"> {t('maintenance.resolving')}</p>
              <p className="text-paragraph-regular text-center cust-mb-2">
                <span className="text-bold"> {t('maintenance.checkAgain')}</span>
              </p>
            </>
          )}
          <p className="text-paragraph-regular text-center cust-mb-2">{t('maintenance.apologise')}</p>
          <div className="d-flex justify-content-center">
            <Button
              meta={{
                name: 'faq',
                title: t('buttons.viewFAQs'),
                type: ButtonType.Primary,
                size: ButtonSize.Large,
              }}
              onClick={() => window.open(`${environment.FAQ_LINK}`)}
            />
          </div>
        </div>
      </Card>
    );
  }
);

export default Maintenance;